<div class="reprogramar-container" [class.select-mode]="$useSelectMode()">
  @if ($useSelectMode()) {
  <!-- Vista con selects en fila -->
  <div class="section">
    <div class="all-fields-row">
      <div class="form-group">
        <label class="section-label">Tipo:</label>
        <app-select [items]="tiposSelectItems" [value]="$tipoSeleccionado()" (keyString)="onTipoChange($event)"
          [hidePlaceholder]="true" hostWidth="100%" inputWidth="100%" />
      </div>

      <div class="form-group">
        <label class="section-label">Reprogramar:</label>
        <app-select [items]="reprogramarSelectItems" [value]="$reprogramarSeleccionado()"
          (keyString)="onReprogramarChange($event)" [hidePlaceholder]="true" hostWidth="100%" inputWidth="100%" />
      </div>

      @if ($reprogramarSeleccionado() === 'otro') {
      <div class="fecha-hora-group">
        <div class="form-group">
          <label>Fecha</label>
          <input type="date" class="form-control" [value]="$fechaPersonalizada()" [min]="getMinDate()"
            (change)="onFechaChange($event)" />
        </div>

        <div class="form-group">
          <label>Hora</label>
          <app-select [items]="horasSelectItems" [value]="$horaPersonalizada()"
            (keyString)="$horaPersonalizada.set($event); actualizarFechaHorarioPersonalizado()" [hidePlaceholder]="true"
            hostWidth="100%" inputWidth="100%" />
        </div>

        <div class="form-group">
          <label>Min</label>
          <app-select [items]="minutosSelectItems" [value]="$minutosPersonalizados()"
            (keyString)="$minutosPersonalizados.set($event); actualizarFechaHorarioPersonalizado()"
            [hidePlaceholder]="true" hostWidth="100%" inputWidth="100%" />
        </div>
      </div>
      }
    </div>
  </div>
  } @else {
  <!-- Vista con radio buttons -->
  <div class="section">
    <label class="section-label">Tipo:</label>
    <div class="radio-group">
      @for (option of tiposOptions; track option.value) {
      <app-radio [name]="'tipo-reprogramacion'" [value]="option.value" [label]="option.label"
        [ngModel]="$tipoSeleccionado()" (valueChange)="onTipoChange($event)" />
      }
    </div>
  </div>

  <div class="section">
    <label class="section-label">Reprogramar:</label>
    <div class="radio-group">
      @for (option of reprogramarOptions; track option.value) {
      <app-radio [name]="'opcion-reprogramar'" [value]="option.value" [label]="option.label"
        [ngModel]="$reprogramarSeleccionado()" (valueChange)="onReprogramarChange($event)" />
      }
    </div>

    @if ($reprogramarSeleccionado() === 'otro') {
    <div class="fecha-hora-container">
      <div class="form-row">
        <div class="form-group fecha-group">
          <label>Fecha</label>
          <input type="date" class="form-control" [value]="$fechaPersonalizada()" [min]="getMinDate()"
            (change)="onFechaChange($event)" />
        </div>

        <div class="form-group hora-group">
          <label>Hora</label>
          <select class="form-control" [value]="$horaPersonalizada()" (change)="onHoraChange($event)">
            <option value="">--</option>
            @for (hora of horasOptions; track hora) {
            <option [value]="hora">{{ hora }}</option>
            }
          </select>
        </div>

        <div class="form-group minutos-group">
          <label>Minutos</label>
          <select class="form-control" [value]="$minutosPersonalizados()" (change)="onMinutosChange($event)">
            <option value="">--</option>
            @for (minuto of minutosOptions; track minuto) {
            <option [value]="minuto">{{ minuto }}</option>
            }
          </select>
        </div>
      </div>
    </div>
    }
  </div>
  }

  <div class="section">
    <label class="section-label">Observaciones</label>
    <textarea class="observaciones-input" [value]="$observaciones()" (input)="onObservacionesChange($event)" rows="2"
      placeholder=""></textarea>
  </div>

  <div class="horario-badge" [class.disponible]="$horarioDisponible() && !$verificandoDisponibilidad()"
    [class.ocupado]="!$horarioDisponible() && !$verificandoDisponibilidad()"
    [class.verificando]="$verificandoDisponibilidad()">
    @if ($verificandoDisponibilidad()) {
    <span class="loading-indicator"></span>
    <span>Verificando disponibilidad...</span>
    } @else if ($horarioDisponible()) {
    <span class="status-icon disponible">✓</span>
    <span>Horario disponible {{ horarioFormateado }}</span>
    } @else {
    <span class="status-icon ocupado">✗</span>
    <span>Horario ocupado {{ horarioFormateado }}</span>
    }
  </div>
</div>

<div class="multiagenda-container">
  <app-multiagenda-day [idDistribuidor]="'153982'" [idPropietario]="'1539820001'"
    [idSeguimiento]="'153982000128830A0005'" [seguimientos]="$horariosOcupados()" [fecha]="$fechaMultiagenda()"
    (fechaChange)="onMultiagendaFechaChange($event)" />
</div>

<div class="footer-actions">

  <app-button text="Reprogramar" icon="check-circle-outline" (click)="onReprogramar()" [disabled]="!puedeReprogramar()"
    tooltipWhenDisabled="Seleccionar horario Disponible y/o Llenar Observaciones" />

  <!--   <button type="button" class="btn-desbloquear flex gap-2 items-center" (click)="onReprogramar()"  [disabled]="!puedeReprogramar()">
   Reprogramar
    <app-icon icon="check-circle-outline" size="3rem" color="--secondary" />
  </button> -->
</div>
